"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDialog = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var theme_1 = __importDefault(require("../../../styles/theme"));
var objectUtilities_1 = require("../../../util/objectUtilities");
var BaseDialog_style_1 = __importDefault(require("./BaseDialog.style"));
/**
 * BaseDialog molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-basedialog-basedialog--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/BaseDialog Source}
 *
 * What's the difference between Dialog and BaseDialog?
 *
 * - Dialogs should contain three parts: title, content, actions (e.g. a button bar).
 * - In most cases, you can simply use `Dialog` which contains all these parts, designed according to our style guide.
 * - If you need more control over the look of the dialog, use `BaseDialog` instead. In this case, you are responsible
 *   for providing the three parts, though you may use `BaseDialogHeader`, `BaseDialogContent`, and `BaseDialogActions`,
 *   so you don't have to implement everything yourself.
 */
var BaseDialog = function (_a) {
    var isOpen = _a.isOpen, children = _a.children, onClose = _a.onClose, onExited = _a.onExited, disableBackdropClick = _a.disableBackdropClick, disableEscapeKeyDown = _a.disableEscapeKeyDown, height = _a.height, minHeight = _a.minHeight, minWidth = _a.minWidth, width = _a.width, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, _b = _a.alignCenter, alignCenter = _b === void 0 ? false : _b, _c = _a.isFullScreenModal, isFullScreenModal = _c === void 0 ? false : _c;
    var classes = (0, BaseDialog_style_1.default)();
    var muiDialogClasses = isFullScreenModal
        ? {
            paper: classes.modalPaper,
            scrollPaper: classes.scrollPaper,
        }
        : {
            paper: classes.dialogPaper,
            scrollPaper: alignCenter ? undefined : classes.alignTop,
        };
    var handleClose = function (_event, reason) {
        switch (reason) {
            case 'backdropClick':
                !disableBackdropClick && onClose();
                return;
            case 'escapeKeyDown':
                !disableEscapeKeyDown && onClose();
                return;
            default:
                (0, objectUtilities_1.exhaustivenessCheck)(reason);
        }
    };
    return ((0, jsx_runtime_1.jsx)(core_1.Dialog, __assign({ open: isOpen, onClose: handleClose, classes: muiDialogClasses, PaperProps: { style: { minWidth: minWidth, minHeight: minHeight, width: width, height: height, maxWidth: maxWidth, maxHeight: maxHeight } }, BackdropProps: { style: { backgroundColor: theme_1.default.colors.backdrop } }, disableRestoreFocus: true, TransitionProps: { onExited: onExited } }, { children: children })));
};
exports.BaseDialog = BaseDialog;
